import React from 'react';
import { Link } from 'react-router-dom';

const rooms = [
  { id: 1, title: 'Studentenkamer Amsterdam Zuid', price: '€450', city: 'Amsterdam', desc: 'Gemeubileerde kamer, 15m², gedeelde badkamer' },
  { id: 2, title: 'Kamer Rotterdam Centrum', price: '€380', city: 'Rotterdam', desc: 'Zelfstandige studio, 22m², eigen keuken' },
  { id: 3, title: 'Studentenhuis Utrecht', price: '€320', city: 'Utrecht', desc: 'Kamer in studentenhuis, 12m², 6 huisgenoten' },
  { id: 4, title: 'Kamer Groningen', price: '€290', city: 'Groningen', desc: 'Ruime kamer, 18m², inclusief gas/water/licht' },
];

export default function RoomsPage() {
  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-5xl font-bold text-center mb-12 text-gray-800">Beschikbare Kamers</h1>
      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        {rooms.map(room => (
          <div key={room.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition">
            <img src={`https://picsum.photos/seed/room${room.id}/400/200`} alt={room.title} className="w-full h-48 object-cover" />
            <div className="p-6">
              <div className="text-2xl font-bold text-blue-600 mb-2">{room.price}<span className="text-sm text-gray-500">/maand</span></div>
              <h3 className="text-xl font-bold mb-2">{room.title}</h3>
              <p className="text-gray-600 mb-4">{room.desc}</p>
              <Link to={`/rooms/${room.id}`} className="text-blue-600 font-semibold hover:text-blue-800">Bekijk details →</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
